module.exports = __webpack_public_path__ + "static/img/why-3.4f61831b.png";